import { Injectable } from "@angular/core";
import { APP } from "./../constants";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";
import { CurrencyPipe } from "@angular/common";
import { numeroALetras } from "src/app/directives/numero-letras";
import { AuthService } from "./auth.service";

@Injectable()
export class FacturacionesService {
  apiUrl = APP.ApiEndpoint;
  urlApp = APP.AppBaseUrl;

  constructor(
    private _http: HttpClient,
    private cp: CurrencyPipe,
    private Authservice: AuthService
  ) {}

  public consecutivo(data: any, callback) {
    const url = `${this.apiUrl}/api/facturacion/consecutivo/`;
    const self = this;
    return this._http.post(url, data).subscribe((result) => {
      callback(result);
    });
  }

  public resolucion(data: any, callback) {
    const url = `${this.apiUrl}/api/facturacion/resolucion/`;
    const self = this;
    return this._http.post(url, data).subscribe((result) => {
      callback(result);
    });
  }
  
  public async listarFacturacionesGuardadas(data: any, callback) {
    const url = `${this.apiUrl}/api/facturacion/listar-guardadas`;
    const self = this;
    return this._http.post(url, data).subscribe((result) => {
      callback(result);
    });
  }

  public guardarFacturaCompraMasivo(data: any, callback) {
    const url = `${this.apiUrl}/api/facturacion/crearCompraMasivo/`;
    const self = this;
    return this._http.post(url, data).subscribe((result) => {
      callback(result);
    });
  }

  public generarFactura(data: any, callback) {
    const url = `${this.apiUrl}/api/facturacion/invoice/`;
    const self = this;
    return this._http.post(url, data).subscribe((result) => {
      callback(result);
    });
  }

}
